import React from 'react';
import { AgentContent } from '@auw/workspace-ui';

interface AgentModePageProps {
  emptyDescription?: string;
}

export const AgentModePage: React.FC<AgentModePageProps> = (props) => {
  return <AgentContent {...props} />;
};
